var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ExecutionResultsDialog", {
    ref: "executionResultsDialog",
    attrs: { title: "Report generation" },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function ({ isError }) {
          return [
            isError
              ? _c(
                  "span",
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { large: "", color: "warning" },
                      },
                      [_vm._v("warning")]
                    ),
                    _vm._v("\n      Failed to generate report.\n    "),
                  ],
                  1
                )
              : _c(
                  "span",
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { large: "", color: "success" },
                      },
                      [_vm._v("check_circle")]
                    ),
                    _vm._v("\n      Report generated successfully.\n    "),
                  ],
                  1
                ),
          ]
        },
      },
      {
        key: "actions",
        fn: function ({}) {
          return [
            _c(
              "PrimaryBtn",
              {
                attrs: { icon: "refresh", color: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.generateAgain()
                  },
                },
              },
              [_vm._v("\n      Generate again\n    ")]
            ),
          ]
        },
      },
      {
        key: "next",
        fn: function ({ fileResults }) {
          return [
            _c(
              "PrimaryBtn",
              {
                attrs: {
                  icon: "open_in_browser",
                  color: "primary",
                  to: { name: "rFrameworkViewer", params: { fileResults } },
                },
              },
              [_vm._v("\n      View report\n    ")]
            ),
            _vm._v(" "),
            _c(
              "SecondaryBtn",
              {
                attrs: { icon: "file_download", color: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.downloadReport(fileResults)
                  },
                },
              },
              [_vm._v("\n      Download offline\n    ")]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }